export default __webpack_public_path__ + "static/media/download_color.07119655.svg";